import { getEnv } from 'common-nextjs';
import Script from 'next/script';

const GA4_TRACKING_ID = getEnv('GA4_TRACKING_ID');
const GOOGLE_REMARKETING_CONVERSION_ID = getEnv(
  'GOOGLE_REMARKETING_CONVERSION_ID',
);

export default function GoogleAnalyticsScripts() {
  return (
    <>
      {GA4_TRACKING_ID && (
        <Script
          src={`https://www.googletagmanager.com/gtag/js?id=${GA4_TRACKING_ID}`}
          strategy="afterInteractive"
          id="gtag-js"
        />
      )}

      {GOOGLE_REMARKETING_CONVERSION_ID && (
        <Script
          src="https://www.googleadservices.com/pagead/conversion.js"
          strategy="afterInteractive"
          id="google-remarketing"
        />
      )}
    </>
  );
}
